export const bypass = {
  maxPastDateSelectionRange:
    import.meta.env.VITE_BYPASS_MAX_PAST_DATE_SELECTION_RANGE || 12,
}
